import { Icon, IconProps } from './Icon';

export const TravGeniusIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 15 21"
  >
    <defs>
      <linearGradient
        id="paint0_linear_5953_29085"
        x1="2.49357"
        y1="17.3966"
        x2="13.0159"
        y2="3.32158"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E52DF5" />
        <stop
          offset="1"
          stopColor="#15C3FF"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5953_29085"
        x1="11.575"
        y1="3.04237"
        x2="-4.52049"
        y2="11.6928"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15C3FF" />
        <stop
          offset="1"
          stopColor="#8DF4DB"
        />
      </linearGradient>
    </defs>
    <path
      d="M7.51758 0.5C11.5424 0.500249 14.8212 3.9394 14.8213 8.16992C14.8213 9.88585 14.2584 11.5797 13.2451 12.9258L7.51758 20.5L1.78906 12.9258C0.775811 11.5797 0.212891 9.88583 0.212891 8.16992C0.212949 3.93925 3.49253 0.5 7.51758 0.5ZM7.48828 3.26562C7.04619 5.76705 5.10595 7.7368 2.61133 8.21582C5.10591 8.69487 7.04619 10.6636 7.48828 13.165L7.51758 13.3291L7.5459 13.165C7.98798 10.6637 9.92834 8.69492 12.4229 8.21582C9.92826 7.73677 7.98799 5.76703 7.5459 3.26562L7.51758 3.10156L7.48828 3.26562Z"
      fill="black"
    />
    <path
      d="M7.51758 0.5C11.5424 0.500249 14.8212 3.9394 14.8213 8.16992C14.8213 9.88585 14.2584 11.5797 13.2451 12.9258L7.51758 20.5L1.78906 12.9258C0.775811 11.5797 0.212891 9.88583 0.212891 8.16992C0.212949 3.93925 3.49253 0.5 7.51758 0.5ZM7.48828 3.26562C7.04619 5.76705 5.10595 7.7368 2.61133 8.21582C5.10591 8.69487 7.04619 10.6636 7.48828 13.165L7.51758 13.3291L7.5459 13.165C7.98798 10.6637 9.92834 8.69492 12.4229 8.21582C9.92826 7.73677 7.98799 5.76703 7.5459 3.26562L7.51758 3.10156L7.48828 3.26562Z"
      fill="url(#paint0_linear_5953_29085)"
    />
    <path
      d="M7.51758 0.5C11.5424 0.500249 14.8212 3.9394 14.8213 8.16992C14.8213 9.88585 14.2584 11.5797 13.2451 12.9258L7.51758 20.5L1.78906 12.9258C0.775811 11.5797 0.212891 9.88583 0.212891 8.16992C0.212949 3.93925 3.49253 0.5 7.51758 0.5ZM7.48828 3.26562C7.04619 5.76705 5.10595 7.7368 2.61133 8.21582C5.10591 8.69487 7.04619 10.6636 7.48828 13.165L7.51758 13.3291L7.5459 13.165C7.98798 10.6637 9.92834 8.69492 12.4229 8.21582C9.92826 7.73677 7.98799 5.76703 7.5459 3.26562L7.51758 3.10156L7.48828 3.26562Z"
      fill="url(#paint1_linear_5953_29085)"
    />
  </Icon>
);
